// extracted by mini-css-extract-plugin
export default {"cls1":"ContentFeedback-cls1_rH7","cls2":"ContentFeedback-cls2___1 ContentFeedback-cls1_rH7"};